import styled from "@emotion/styled";

export const CardsWrapper = styled.div(({theme}) => ({
  display: "flex",
  width: "100%",
  // gridTemplateColumns: theme?.breakpoints?.isMobile
  //   ? "repeat(1, 1fr)"
  //   : theme?.breakpoints?.md
  //     ? "repeat(3, 1fr)"
  //     : "repeat(4, 1fr)",
  // marginBottom: theme?.breakpoints?.isMobile ? 16 : 20,
}));

export const SliderCardsWrapper = styled.div(({theme}) => ({
  display: "flex",
  paddingBottom: 10,
  width: "100%",
  gridTemplateColumns: theme?.breakpoints?.isMobile
    ? "repeat(1, 1fr)"
    : theme?.breakpoints?.md
      ? "repeat(3, 1fr)"
      : "repeat(4, 1fr)",
  // marginBottom: theme?.breakpoints?.isMobile ? 16 : 35,
}));

export const InnerWrapper = styled.div(({theme, styles}) => ({
  position: "relative",
  width: "100%",
  height: "100%",
  minHeight: "auto",
  display: "grid",
  gridColumn: "1/-1",
  gridGap: theme?.breakpoints?.isMobile ? 10 : 20,
  gridTemplateColumns: theme?.breakpoints?.isMobile
    ? "repeat(1, 1fr)"
    : theme?.breakpoints?.md
      ? "repeat(2, 1fr)"
      : "repeat(4, 1fr)",
  backgroundColor: "transparent",
  zIndex: 1,
  boxSizing: "border-box",
  ...styles,
}));

export const SliderWrapper = styled.section(({theme, backgroundColor, styles}) => {
  const color =
    backgroundColor === "white"
      ? theme?.colors?.primaryWhite
      : theme?.colors?.backgroundGrey;
  return {
    width: "100%",
    gridColumn: "1/-1",
    backgroundColor: color,
    paddingTop: theme?.breakpoints?.isMobile ? 20 : 30,
    // paddingBottom: theme?.breakpoints?.isMobile ? 20 : 30,
    ...styles,
    ".swiper-scrollbar": {
      bottom: theme?.breakpoints?.isMobile ? "-16px" : "-35px",
      height: theme?.breakpoints?.isMobile ? 3 : 6,
      borderTopWidth: theme?.breakpoints?.isMobile ? 1 : 2,
      borderTopStyle: "solid",
      borderTopColor: color,
      backgroundColor: theme?.colors?.primaryGrey,
      WebkitClipPath: theme?.breakpoints?.isMobile
        ? "polygon(1% 100%, 1.2% 0%, 99% 0%, 98.8% 100%)"
        : "polygon(1% 100%, 1.6% 0%, 99% 0%, 98.6% 100%)",
      clipPath: theme?.breakpoints?.isMobile
        ? "polygon(1% 100%, 1.2% 0%, 99% 0%, 98.8% 100%)"
        : "polygon(1% 100%, 1.6% 0%, 99% 0%, 98.6% 100%)",
    },
    ".swiper-scrollbar-drag": {
      bottom: 0,
      top: -2,
      width: "auto",
      height: 8,
      backgroundColor: theme?.colors?.brandBlue,
      WebkitClipPath: "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
      clipPath: theme?.breakpoints?.isMobile
        ? "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)"
        : "polygon(0% 100%, 1% 0%, 100% 0%, 99% 100%)",
      cursor: "pointer",
      borderRadius: 0,
      transitionDuration: theme?.breakpoints?.isMobile
        ? "0.4s !important"
        : "0.1s !important",
      transitionTimingFunction: theme?.breakpoints?.isMobile ? "ease-in-out" : "ease",
    },
    ".swiper-scrollbar-horizontal": {
      left: 0,
      width: "100%",
    },
    ".swiper-slide": {
      width: "auto",
      height: "100%",
    },
  };
});
